function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "New_Gradient_Swatch_1",
  x1: 256,
  x2: 256,
  y2: 512,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ededee"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#cfd0d2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#a6a8ab"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "New_Gradient_Swatch_2",
  x1: 256,
  y1: 418.1,
  x2: 256,
  y2: 93.9,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#231f20"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6d6e70"
})));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M256,512c141,0,256-115,256-256S397,0,256,0,0,115,0,256,115,512,256,512Z",
  fillRule: "evenodd",
  fill: "url(#New_Gradient_Swatch_1)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M272.79,311.4c-3.06,16.64-13.33,26.31-30.48,26.31A31.1,31.1,0,0,1,220.14,329c-6.95-6.67-9.18-15.88-9.18-25.25,0-11,1.51-22.2,5.81-32.37a83.26,83.26,0,0,1,15.32-24.07A162.4,162.4,0,0,1,246,234.62c5.58-4.75,11.21-9.42,16.67-14.31,8.36-7.5,26.44-24.12,24.6-36.74-1.73-11.75-7.2-22.09-18.14-27.45-11.68-5.73-26-4.08-37.5,1.39a50.72,50.72,0,0,0-27.48,32.73c-4.34,16.31-14.91,27.84-32.42,27.84a32.12,32.12,0,0,1-23.82-10c-5.82-6.07-9.64-13.34-9.64-21.91,0-15.47,5.4-29.91,13.49-42.93,9.53-15.26,23.13-26.79,38.78-35.4,18.23-10,38.4-13.9,59-13.9,19.07,0,38,3.27,55.23,11.65,15.34,7.37,28.32,17.83,37.74,32.12a80,80,0,0,1,13.41,44.59c0,11.72-2.26,23.18-7.82,33.59a103.23,103.23,0,0,1-17.92,24.25c-11.31,11.1-23.46,21.79-35.23,32.37a131.6,131.6,0,0,0-10.71,10.74,38.33,38.33,0,0,0-5.38,7.58l-.06.11a35.86,35.86,0,0,0-2.76,6.87c-1.28,4.43-2.27,9.13-3.25,13.64ZM244.55,418.1a38.45,38.45,0,0,1-25.87-9.66c-8.14-7.05-11.44-16.72-11.44-27.36a35.47,35.47,0,0,1,10.88-26.25,36.52,36.52,0,0,1,26.43-10.61,36.33,36.33,0,0,1,36.76,36.86c0,10.57-3.34,20.16-11.31,27.24A37.25,37.25,0,0,1,244.55,418.1Z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M281.7,311.4c-3.05,16.64-13.33,26.31-30.47,26.31A31.11,31.11,0,0,1,229,329c-6.95-6.67-9.18-15.88-9.18-25.25,0-11,1.51-22.2,5.82-32.37A83.27,83.27,0,0,1,241,247.36a162.33,162.33,0,0,1,13.88-12.73c5.58-4.75,11.22-9.42,16.68-14.31,8.36-7.5,26.44-24.12,24.59-36.74-1.73-11.75-7.2-22.09-18.14-27.45-11.68-5.73-26-4.08-37.5,1.39A50.73,50.73,0,0,0,213,190.24c-4.34,16.31-14.91,27.84-32.42,27.84a32.11,32.11,0,0,1-23.82-10c-5.82-6.07-9.64-13.34-9.64-21.91,0-15.47,5.4-29.91,13.48-42.93,9.53-15.26,23.13-26.79,38.79-35.4,18.22-10,38.39-13.9,59-13.9,19.08,0,38,3.27,55.24,11.65,15.33,7.37,28.32,17.83,37.74,32.12a80.06,80.06,0,0,1,13.41,44.59c0,11.72-2.26,23.18-7.82,33.59a103.23,103.23,0,0,1-17.92,24.25c-11.31,11.1-23.46,21.79-35.23,32.37a130.38,130.38,0,0,0-10.71,10.74,38.09,38.09,0,0,0-5.39,7.58l-.06.11a36.36,36.36,0,0,0-2.76,6.87c-1.28,4.43-2.27,9.13-3.25,13.64ZM253.47,418.1a38.45,38.45,0,0,1-25.88-9.66c-8.13-7.05-11.44-16.72-11.44-27.36A35.44,35.44,0,0,1,227,354.82a36.5,36.5,0,0,1,26.43-10.61,36.34,36.34,0,0,1,36.76,36.86c0,10.57-3.35,20.16-11.32,27.24A37.23,37.23,0,0,1,253.47,418.1Z",
  fillRule: "evenodd",
  fill: "url(#New_Gradient_Swatch_2)"
});

function SvgHelp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "help") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.0a6a08f09a1e4b72e2d905dd80bb7c96.svg";
export { ForwardRef as ReactComponent };